import { Button, ButtonGroup, Flex, Text } from '@chakra-ui/react';
import { moveWidgetByDirection } from 'modules/Editor/Editor.helpers';
import { useAppSelector } from 'modules/Editor/store';
import { selectWidgetLayerOrder } from 'modules/Editor/store/infographSelector';
import { selectActivePage } from 'modules/Editor/store/pageSelector';
import { selectActiveWidgetIds, selectActiveWidgets } from 'modules/Editor/store/widgetSelector';
import { Keyboard } from 'modules/common/components/Keyboard';
import { memo, useEffect } from 'react';

import { layerOptions } from './LayerMenu.config';

export const LayerMenuOptions = memo(() => {
  const activeWidgetIds = useAppSelector(selectActiveWidgetIds);
  const activeWidgets = useAppSelector(selectActiveWidgets);
  const isMultiSelect = activeWidgets.length > 1;
  const activePageId = useAppSelector(selectActivePage);
  const widgetLayerOrder = useAppSelector(selectWidgetLayerOrder(activePageId));
  // We use the useEffect hook to trigger a re-render,
  // otherwise the widgetLayerOrder variable would be declared but unused.
  useEffect(() => {}, [widgetLayerOrder]);

  return (
    <ButtonGroup
      data-testid='widget-layer-menu-options'
      gap={1}
      p={2}
      variant='outline'
      spacing='0'
      display='flex'
      size='sm'
      flexDir='column'
    >
      {layerOptions.map((layerOption, index) => {
        const onClick = () => moveWidgetByDirection(layerOption.direction);
        return (
          <Button
            variant='ghost'
            key={index}
            display='flex'
            gap={3}
            onClick={onClick}
            borderRadius='base'
            disabled={layerOption.checkIsDisabled({ activeWidgetIds, isMultiSelect })}
          >
            <Flex flex={1} gap={2} fontWeight='normal' align='center'>
              {layerOption.icon}
              <Text align='left' color='font.500'>
                {layerOption.label}
              </Text>
            </Flex>
            <Flex>
              <Keyboard
                color='font.300'
                fontSize={'xs'}
                shortcut={layerOption.shortcuts.others}
                macOs={layerOption.shortcuts.macOs}
              />
            </Flex>
          </Button>
        );
      })}
    </ButtonGroup>
  );
});
LayerMenuOptions.displayName = 'LayerMenuOptions';
